import { useDateCountdown } from '@/hooks/helpers/useDateCountdown'
import { cn } from '@/lib/utils'

export function PollCountdown({
	endDate,
	onEnd,
	className
}: {
	endDate: Date
	onEnd?: () => void
	className?: string
}) {
	const { days, hours, minutes, seconds } = useDateCountdown({
		date: endDate,
		onElapsed: () => {
			onEnd?.()
		}
	})
	const formattedDate = [days, hours, minutes, seconds].map(x => x.toString().padStart(2, '0')).join(':')

	return <span className={cn('text-[1.75rem] leading-none w-[10ch]', className)}>{formattedDate}</span>
}
